import { assertUnreachable } from 'lib/staticAssert/staticAssertUtils'
import type { TripPlannerSurfaceActivityEntry } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityEntryTypes'
import { boundActivityDisplayText } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityDisplayText'
import { formatAssistantRoomsOccupancyText } from 'tripPlanner/assistant/utils/assistantRoomOccupancyText'
import type { ListingDrawerHotelDateSelection } from '../ListingDrawerSearchDates'

function formatDateSelectionSuffix(dateSelection: ListingDrawerHotelDateSelection): string {
  switch (dateSelection.type) {
    case 'specific':
      return `, ${dateSelection.checkIn} to ${dateSelection.checkOut}`
    case 'flexible':
      return `, flexible ${dateSelection.flexibleNights} nights`
    case 'anytime':
      return ''
    default:
      return assertUnreachable(dateSelection)
  }
}

// Included so a rooms-only reapply (same destination/dates, different occupancy) produces a
// displayText distinct from the original search -- otherwise the two are indistinguishable and
// the server's kind+displayText grouping silently absorbs the occupancy change into the earlier
// entry, losing the fact that the customer changed party size at all.
function formatOccupancySuffix(occupancies: Array<App.Occupants>): string {
  const occupancyText = formatAssistantRoomsOccupancyText(occupancies)
  return occupancyText ? `, ${occupancyText}` : ''
}

export function buildHotelSearchSubmittedActivityEntry(
  searchQuery: string,
  dateSelection: ListingDrawerHotelDateSelection,
  occupancies: Array<App.Occupants>,
): TripPlannerSurfaceActivityEntry {
  return {
    kind: 'hotel_search_submitted',
    label: 'Searched hotels',
    displayText: boundActivityDisplayText(
      `Searched hotels for "${searchQuery}"${formatDateSelectionSuffix(dateSelection)}${formatOccupancySuffix(occupancies)}`,
    ),
    sourcePath: 'trip_planner.search.hotel',
    dataClassification: 'personalised_surface',
    occurredAt: new Date().toISOString(),
  }
}
